import React from 'react';
import Chart from 'react-apexcharts';
import Color from 'color';

const RingChart = ({ values, size = 200, marginBetweenTracks = 7, forceColor }) => {
  const options = React.useMemo(() => {
    const colors = [];

    if (forceColor) {
      colors.push(Color(forceColor).hex());
    } else {
      colors.push(values[0] >= 100 ? '#4caf50' : '#e91e63');
    }

    return {
      plotOptions: {
        radialBar: {
          track: {
            // background: '#fff',
            strokeWidth: '67%',
            margin: marginBetweenTracks, // margin is in pixels
          },
          dataLabels: {
            showOn: 'always',
            name: {
              show: false,
            },
            value: {
              offsetY: 5,
              formatter: val => `${val}%`,
              color: '#111',
              fontSize: '17px',
              show: true,
            },
          },
        },
      },
      stroke: {
        lineCap: 'round',
      },
      colors,
    };
  }, [values, forceColor]);
  return <Chart options={options} series={values} type="radialBar" width={size} />;
};

export default RingChart;
